module.exports = __webpack_public_path__ + "static/media/octobre-rose-background.95e8bd73.jpg";